import React from "react";

import { templates } from "@reactivated";

import { FlagshipStoreInfoMapSSR } from "../apps/retail-locator/FlagshipStoreInfoMapSSR";

export const Template = (
    props: templates.FlagshipInfoTemplate,
): React.JSX.Element => {
    return <FlagshipStoreInfoMapSSR {...props} />;
};
